// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_og-0";
export var discountCodeInput = "_og-1";